export default __webpack_public_path__ + "static/media/integrity1.1b1d0054.png";